import { render, staticRenderFns } from "./viewDetils.vue?vue&type=template&id=767fa204&scoped=true&"
import script from "./viewDetils.vue?vue&type=script&lang=js&"
export * from "./viewDetils.vue?vue&type=script&lang=js&"
import style0 from "./viewDetils.vue?vue&type=style&index=0&id=767fa204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767fa204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('767fa204')) {
      api.createRecord('767fa204', component.options)
    } else {
      api.reload('767fa204', component.options)
    }
    module.hot.accept("./viewDetils.vue?vue&type=template&id=767fa204&scoped=true&", function () {
      api.rerender('767fa204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/reconciliationDetails/components/viewDetils.vue"
export default component.exports